// src/components/Login.js

import React, { useState } from 'react';
import { auth } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate, Link } from 'react-router-dom';
import './Login.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/');
    } catch (err) {
      setError('Invalid email or password');
      console.error('Login error:', err);
    }
  };

  return (
    <div className="login-page">
      <div className="login-glow login-glow-a" aria-hidden="true" />
      <div className="login-glow login-glow-b" aria-hidden="true" />

      <div className="login-shell">
        <section className="login-brand">
          <p className="login-kicker">DocExtract Platform</p>
          <h1>Welcome back</h1>
          <p className="login-subtitle">
            Run invoice operations with confidence using high-accuracy extraction,
            validation, and workflow controls in one workspace.
          </p>

          <div className="login-metrics" aria-hidden="true">
            <div className="metric-card">
              <span className="metric-value">99.2%</span>
              <span className="metric-label">Field Match Accuracy</span>
            </div>
            <div className="metric-card">
              <span className="metric-value">4x</span>
              <span className="metric-label">Faster Document Reviews</span>
            </div>
            <div className="metric-card">
              <span className="metric-value">Real-time</span>
              <span className="metric-label">Validation Feedback</span>
            </div>
          </div>
        </section>

        <section className="login-panel" aria-label="Sign in form">
          <div className="login-panel-inner">
            <h2>Sign in to your workspace</h2>
            <p className="login-panel-text">
              Continue to process, validate, and manage invoices.
            </p>

            {error && <p className="login-error">{error}</p>}

            <form onSubmit={handleLogin} className="login-form">
              <label htmlFor="login-email">Work email</label>
              <input
                id="login-email"
                type="email"
                placeholder="name@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="username"
              />

              <label htmlFor="login-password">Password</label>
              <input
                id="login-password"
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />

              <button type="submit">Continue</button>
            </form>

            <p className="login-footer-text">
              New to DocExtract? <Link to="/register">Create an account</Link>
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Login;
